module.exports = __webpack_public_path__ + "static/media/400102_02.aed3e2c5.png";